import { api } from "./api";

export const getStoreListApi = () => {
    return api.get(`/product/restriction/getStoreList`);
};

export const getRegionalRestrictionsListApi = (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.pageNumber) queryParams.append('pageNumber', params.pageNumber);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize);
    if (params.searchColumn) queryParams.append('searchColumn', params.searchColumn);
    if (params.searchValue) queryParams.append('searchValue', params.searchValue);
    if (params.fromDate) queryParams.append('fromDate', params.fromDate);
    if (params.toDate) queryParams.append('toDate', params.toDate);

    const queryString = queryParams.toString();
    return api.get(`/product/restriction/list${queryString ? `?${queryString}` : ''}`);
};

export const getItemsListApi = (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.item_type) queryParams.append('item_type', params.item_type);
    if (params.item_category) queryParams.append('item_category', params.item_category);
    if (params.item_group) queryParams.append('item_group', params.item_group);
    if (params.item_manufacturer) queryParams.append('item_manufacturer', params.item_manufacturer);

    const queryString = queryParams.toString();
    return api.get(`/product/restriction/itemslist${queryString ? `?${queryString}` : ''}`);
};

export const addRegionalRestrictionApi = (params) => {
    return api.post(`/product/restriction/add`, JSON.stringify(params));
};

// Dropdown filter APIs (using existing endpoints)
export const getCategoriesApi = () => {
    return api.get(`/settings/itemgcategory/dropdown`);
};

export const getItemTypesApi = () => {
    return api.get(`/settings/itemgtype/dropdown`);
};

export const getItemGroupsApi = () => {
    return api.get(`/settings/itemgroup/dropdown`);
};

export const getManufacturersApi = () => {
    return api.get(`/settings/manufacturers`);
};

// Sub-table APIs for expanded row data
export const getItemsByStoreIdApi = (storeId) => {
    return api.get(`/product/restriction/list/itemByStoreId?store_id=${storeId}`);
};

export const getRestrictionByItemIdApi = (itemId, storeId) => {
    return api.get(`/product/restriction/getByItemId?item_id=${itemId}&store_id=${storeId}`);
};

// Item-based view API (we'll use the items list and transform it)
export const getRegionalRestrictionsItemListApi = (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.pageNumber) queryParams.append('pageNumber', params.pageNumber);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize);
    if (params.searchColumn) queryParams.append('searchColumn', params.searchColumn);
    if (params.searchValue) queryParams.append('searchValue', params.searchValue);
    if (params.fromDate) queryParams.append('fromDate', params.fromDate);
    if (params.toDate) queryParams.append('toDate', params.toDate);

    const queryString = queryParams.toString();
    return api.get(`/product/restriction/itemslist${queryString ? `?${queryString}` : ''}`);
};
